import type { PortalClientDto } from '@supply-mover-2-0/shared';
import { clientCustomerNumber } from '@supply-mover-2-0/shared';

/**
 * Customer-facing client id: the external id (what the customer knows
 * themselves as with this vendor), falling back to the internal id —
 * same convention as the CRM's identity displays. PD-17381 — the rule lives
 * in `clientCustomerNumber` so this matches the Customer ID printed on the
 * customer's statements.
 */
export function clientDisplayId(
	client: Pick<PortalClientDto, 'id' | 'externalId'>,
): string {
	return clientCustomerNumber(client);
}
